import { first, last } from 'lodash';
import { useEffect, useState } from 'react';
import { Img } from '@zapier/design-system/dist/components/display/Img';
import { css } from '@emotion/core';
import { Colors, Typography } from '@zapier/design-system/dist/theme';
import { getInitialsFromString, isolateComponent, labelStyles, withModifier, } from '@zapier/common-utils';
const getNameInitials = (name) => {
    const initials = getInitialsFromString(name.trim());
    const firstLetter = first(initials);
    if (!firstLetter) {
        return '';
    }
    return initials.length === 1
        ? String(firstLetter)
        : `${firstLetter}${last(initials)}`;
};
const Styles = labelStyles(__filename, {
    root: (props) => [
        css({
            alignItems: 'center',
            background: Colors.grey300,
            borderRadius: '50%',
            display: 'inline-flex',
            justifyContent: 'center',
            overflow: 'hidden',
            position: 'relative',
        }),
        withModifier(`${props.size}`, {
            height: props.size,
            width: props.size,
        }),
        props.isBlock &&
            withModifier('block', {
                display: 'flex',
            }),
    ],
    initials: ({ size }) => [
        css(Object.assign(Object.assign({}, Typography.allCaps700), { color: Colors.black })),
        size &&
            withModifier(String(size), {
                fontSize: Math.floor(size * 0.45),
            }),
    ],
});
export const Avatar = (props) => {
    const [hasError, setHasError] = useState(false);
    const { name, url, size } = props;
    const initials = name ? getNameInitials(name) : null;
    useEffect(() => {
        if (hasError) {
            setHasError(false);
        }
    }, [props.url]);
    return (isolateComponent("div", { "aria-hidden": props.ariaHidden, "aria-label": name, css: Styles.root(props), role: "img" }, url && !hasError ? (isolateComponent(Img, { alt: name, ariaHidden: true, height: size, lazyloadOffset: props.shouldLazilyLoad ? undefined : null, onError: () => setHasError(true), src: url, width: size })) : (isolateComponent("span", { css: Styles.initials(props) }, initials))));
};
Avatar.defaultProps = {
    shouldLazilyLoad: true,
    size: 30,
};
//# sourceMappingURL=Avatar.js.map
